import { Component, OnInit, ComponentFactoryResolver, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { FormController } from '../../../../framework/controllers/FormController';
import { ApiService } from '../../../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';
import { NestedNavigationService } from '../../../../services/nested-navigation/nested-navigation.service';
import { BreadCrumbsService, BreadCrumb } from '../../../../services/bread-crumbs/bread-crumbs.service';
import { ToolbarActionsService } from '../../../../services/toolbar-actions/toolbar-actions.service';
import { ChartComponent, PlotAreaClickEvent, SeriesClickEvent, SeriesLabels } from '@progress/kendo-angular-charts';
import { exists } from 'fs';
import { MfControlPopupComponent } from '../../../../framework/components/mf-control-popup/mf-control-popup.component';
import * as saveAs from 'file-saver';
//import { saveAs } from "@progress/kendo-file-saver";

@Component({
  selector: 'app-report-builder-executor',
  templateUrl: './report-builder-executor.component.html',
  styleUrls: ['./report-builder-executor.component.css']
})
export class ReportBuilderExecutorComponent extends FormController implements OnInit {
  public advancedFilters = new Array();
  public uiData: any;
  constructor(apiService?: ApiService,
    route?: ActivatedRoute,
    componentFactoryResolver?: ComponentFactoryResolver,
    messageService?: ToastrService,
    confirmationService?: ConfirmationService,
    dialogService?: MatDialog,
    public auth?: IdentityAuthService,
    nestedNavigationService?: NestedNavigationService,
    public breadCrumbService?: BreadCrumbsService,
    toolbarActionService?: ToolbarActionsService,
    cdr?: ChangeDetectorRef) {
    super(apiService, route, componentFactoryResolver, messageService, confirmationService, dialogService, auth, nestedNavigationService, breadCrumbService, cdr, toolbarActionService);

  }
  public loadingLookups: boolean = false;
  public elementsLoading: boolean = false;
  public loadingLookupsTask: any;
  public data: any = {};
  public refreshingData: boolean;
  public currentFormat: any;

  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 3,
    font: 'bold 16px Arial, sans-serif'
  };
  ngOnInit() {
    //this.breadCrumbService.breadcrumbs.push(new BreadCrumb({
    //  id: 0,
    //  header: 'Randomisation',

    //  active: true
    //}));
    this.parent.currentRouteParamsChange.subscribe(o => {
      if (this.parent.currentRouteParams["id_1"])
        this.entityId = this.parent.currentRouteParams["id_1"];
      else this.entityId = this.parent.currentRouteParams["id_2"];
      this.load();
    });


    if (this.parent.currentRouteParams["id_1"])
      this.entityId = this.parent.currentRouteParams["id_1"];
    else this.entityId = this.parent.currentRouteParams["id_2"];
    this.load();
  }
  public  load() {
    this.advancedFilters = [];
    this.uiData = null;
    if (this.toolbarActionService.selectedFormId != this.formIndex)
      return;
    if (this.parent.currentRouteParams["id_15"] && this.parent.currentRouteParams["id_15"] != this.entityId) {
      this.data = {}
      this.uiData = null;
      this.entityId = this.parent.currentRouteParams["id_15"];
    }
    if (this.entityId) {
      this.loading = true;
      this.apiService.get("/api/ReportBuilder/Executor/" + this.entityId)
        .subscribe(async res => {
          this.loading = false;
          this.data = res;

          if (this.data.dynamicReportAllowedFormats) {
            var defaultFormat = this.data.dynamicReportAllowedFormats.filter(o => { return o.default });
            if (
              (defaultFormat.length > 0 && defaultFormat[0].reportFormat == 3)
              || (this.data.dynamicReportAllowedFormats.length == 1 && this.data.dynamicReportAllowedFormats[0].reportFormat == 3)
            ) {
              if (this.data.reportQueryFilter)
                await this.loadLookups();

              this.generate(3);
            }
            else {
              if (this.data.reportQueryFilter)
                this.loadLookups();
            }
          }
          else {
            if (this.data.reportQueryFilter)
              this.loadLookups();
          }


        }, err => {
          this.loading = false;
        })
    }
  }

  public async loadLookups() {
    this.loadingLookups = true;
    this.loadingLookupsTask = this.apiService.get("/api/ReportBuilder/executorLookups/" + this.entityId).toPromise();
    var res = await this.loadingLookupsTask;
    this.loadingLookups = false;
    this.data.reportQueryFilter = res;

    if (this.data.reportQueryFilter
      && this.data.reportQueryFilter.reportEntity
      && this.data.reportQueryFilter.reportEntity.reportQuerySelectGroup
      && this.data.reportQueryFilter.reportEntity.reportQuerySelectGroup.reportQuerySelects) {

      var required = this.data.reportQueryFilter.reportEntity.reportQuerySelectGroup.reportQuerySelects.filter(o => { return o.required });
      required.forEach(o => {
        var filterValue = null;
        var defaultVal = o.reportQueryFilterLookupValues?.filter((f) => f.isDefault);
        if (defaultVal && defaultVal.length > 0) {
          filterValue = defaultVal[0].id
        }
          this.advancedFilters.push({ column: o, filterValue:filterValue })
      });
    }
  }

  public refreshData() {
    this.dialogService.open(MfControlPopupComponent, {
      data: { title: 'Refreshing data can be an intensive and long running process. Are you sure you want to proceed?', actions: ['Proceed', 'Cancel'] },
    }).afterClosed().subscribe(result => {
      if (result == 'Proceed') {
        this.refreshingData = true;
        this.apiService.post("/api/ReportBuilder/refreshData/" + this.entityId)
          .subscribe(res => {
            this.refreshingData = false;
            this.messageService.success('Refreshing Complete');
            this.data.dataLastRefreshed = res.dataLastRefreshed;
            if (this.data.reportQueryFilter)
              this.loadLookups();
            if (this.uiData)
              this.generate(3);
          }, err => {
            this.refreshingData = false;
          })
      }
    });
  }

  public clearFilters() {
    this.advancedFilters = new Array();
    this.generate(3);
  }

  public generate(reportFormat?) {

    if (this.currentFormat != reportFormat)
      this.uiData = null;
    this.currentFormat = reportFormat;
    if (!this.uiData)
      this.loading = true;
    else this.elementsLoading = true;
    var patientId = this.parent.currentRouteParams["id_1"];
    var consultationId = this.parent.currentRouteParams["id_2"]
    var params = '';
    //var params = '?patientId=' + patientId;
    //if (consultationId)
    //  params += '&consultationId=' + consultationId;
    var filters = new Array();
    this.advancedFilters.forEach(o => {
      o.columnName = o.column.columnName
      o.valueType = o.column.valueType;
      if (!o.start && !o.end)
        filters.push(o);
      if (o.start) {
        var clone = Object.assign({}, o);
        clone.whereExpressionTypeEnum = 3
        clone.filterValue = "'" + o.start["shortDateTime"]() + "'"
        filters.push(clone);
      }
      if (o.end) {
        var clone = Object.assign({}, o);
        clone.whereExpressionTypeEnum = 4
        clone.filterValue = "'" + o.end["shortDateTime"]() + "'"
        filters.push(clone);
      }
    })
    params += '?reportFormat=' + reportFormat;
    if (reportFormat == 3) {
      this.apiService.post("/api/ReportBuilder/GenerateReport/" + this.entityId + params, { Filters: filters, startCount: 0, pageSize: 9999999, selectedColumns: [{ columnName: "Id" }] })
        .subscribe(res => {
          res.forEach(o => {
            if (!o.data)
              o.data = new Array();
            if (o.categoryIsDates) {
              o.data.forEach(d => {
                d.category = new Date(d.category)
              })
              o.baseUnit = 'months'
            }
            if (o.data) {
              var distinctCategories = o.data.filter(
                (thing, i, arr) => arr.findIndex(t => t.category.toString() === thing.category.toString()) === i
              );
              if (distinctCategories.length <= 20)
                o.legendVisible = true;
              else
                o.legendVisible = false;

              var distinctMainCategories = o.data.filter(
                (thing, i, arr) => arr.findIndex(t => t.mainCategory === thing.mainCategory && t.subCategory === thing.subCategory) === i
              );
              var distinctMainCategories = o.data.filter(
                (thing, i, arr) => arr.findIndex(t => t.mainCategory === thing.mainCategory && t.subCategory === thing.subCategory) === i
              );
              o.series = new Array();
              distinctMainCategories.forEach(cat => {
                var data = o.data.filter((d) => d.mainCategory == cat.mainCategory && d.subCategory === cat.subCategory);
                o.series.push({ data: data, name: (cat.subCategory ? null : cat.mainCategory), subCategory: cat.subCategory, mainCategory: cat.mainCategory, seriesType: data.length > 0 ? data[0].seriesType : null })
              })
              o.categories = distinctCategories.map(o => { return o.category })
            }
            o.seriesLabels = {
              visible: true, // Note that visible defaults to false
              padding: this.seriesLabels.padding,
              font: this.seriesLabels.font
            };
            //Find only last series item and enable label so that it displays at the top of the stacked
            if (o.data.filter(q => q.subCategory).length > 0) {

              var distinctSubCategories = o.data.filter(
                (thing, i, arr) => arr.findIndex(t => t.mainCategory === thing.mainCategory) === i
              );
              distinctSubCategories.forEach(sub => {
                var subs = o.series.filter(q => q.mainCategory == sub.mainCategory);
                subs[subs.length - 1].showStackSeriesLabels = true
                //subs[subs.length - 1].seriesLabels.content = this.stackSeriesLabelContent
              })
            }
            if (o.data.length > 0 && o.data[0].format) {
              o.seriesLabels.format = o.data[0].format
            }
            if (o.uiTemplate == 'StackedColumnChart' || o.uiTemplate == 'StackedBarChart')
              o.seriesLabels.visible = false;
            if ((o.uiTemplate == 'ColumnChart')
              && o.data.length > 40) {
              o.seriesLabels.visible = false;
            }
            if (o.uiTemplate == 'StackedColumnChart' || o.uiTemplate == 'StackedBarChart') {
              o.series.forEach(ser => {
                var dataFormatted = new Array();
                if (distinctSubCategories) {
                  var distinctStackGroups = o.data.filter(
                    (thing, i, arr) => arr.findIndex(t => t.stackGroup === thing.stackGroup) === i
                  );

                  var categoryTotals = {};
                  distinctStackGroups.forEach(stack => {
                    o.categories.forEach(cat => {
                      o.data.filter(catD => {
                        return catD.stackGroup == stack.stackGroup && cat.toString() == catD.category.toString()
                      }).forEach(z => {
                        if (typeof categoryTotals[stack.stackGroup + z.category] == "undefined")
                          categoryTotals[stack.stackGroup + z.category] = 0
                        categoryTotals[stack.stackGroup + z.category] += z.value;
                      })
                    });
                  });
                  o.categories.forEach(cat => {
                    var seriesStackGroup = ser.data[0].stackGroup;
                    var seriesFillColor = ser.data[0].fillColor;


                    var existingItem;
                    var exists = ser.data.filter(o => { return o.category.toString() == cat.toString() });


                    if (exists.length > 0)
                      existingItem = exists[0]
                    else existingItem = { value: 0, stackGroup: seriesStackGroup, category: cat, fillColor: seriesFillColor };
                    existingItem.perc = Math.round(existingItem.value / categoryTotals[seriesStackGroup + cat] * 100)

                    existingItem.tooltipLabel = 'subCategory'
                    dataFormatted.push(existingItem)
                  })
                }
                else {
                  var categoryTotals = {};
                  o.categories.forEach(cat => {
                    o.data.filter(catD => {
                      return catD.category == cat
                    }).forEach(z => {
                      if (typeof categoryTotals[cat] == "undefined")
                        categoryTotals[cat] = 0
                      categoryTotals[cat] += z.value;
                    })
                  });
                  o.categories.forEach(cat => {

                    var existingItem;
                    var exists = ser.data.filter(o => { return o.category == cat });


                    if (exists.length > 0)
                      existingItem = exists[0]
                    else existingItem = { value: 0 };
                    existingItem.perc = Math.round(existingItem.value / categoryTotals[cat] * 100)
                    existingItem.tooltipLabel = 'mainCategory'
                    dataFormatted.push(existingItem)

                  })
                }
                ser.data = dataFormatted
              })
            }
          })
          this.uiData = res;

          this.loading = false; this.elementsLoading = false;
        }, err => {
          if (err && err.error && err.error.objects && err.error.objects.length > 0 && err.error.objects[0].value)
            this.messageService.error(err.error.objects[0].value.Message, "Report Failed")
          else this.messageService.error('Could not generate report', "Report Failed")
          console.dir(err);
          this.loading = false; this.elementsLoading = false;
        })
    }
    else {
      this.apiService.post("/api/ReportBuilder/GenerateReport/" + this.entityId + params, { Filters: filters, startCount: 0, pageSize: 9999999, selectedColumns: [{ columnName: "Id" }] })
        .subscribe(res => {
          //this.data = res;
          if (res) {
            this.apiService.downloadFile(this.apiService.appSettings.apiServiceAddress + "/api/ReportBuilder/downloadReport/" + res.id).subscribe(respData => {
              var blob = new Blob([respData]);
              this.apiService.saveFile(blob, res.fileName);
              this.loading = false;
              //$scope.cdr.detectChanges();
            }, error => {
              this.loading = false;
              //this.cdr.detectChanges();
              console.log('err');
            });
          }
        }, err => {
          if (err && err.error && err.error.objects && err.error.objects.length > 0 && err.error.objects[0].value)
            this.messageService.error(err.error.objects[0].value.Message, "Report Failed")
          else this.messageService.error('Could not generate report', "Report Failed")
          console.dir(err);
          this.loading = false;
        })
    }
  }
  public toggleLabels(element) {
    var visible = element.seriesLabels.visible;
    element.seriesLabels = {
      visible: !visible, // Note that visible defaults to false
      padding: this.seriesLabels.padding,
      font: this.seriesLabels.font,
      format: element.seriesLabels.format
    }
  }

  public addFilter() {
    this.advancedFilters.push({})
  }
  public removeFilter(item) {
    this.advancedFilters.splice(this.advancedFilters.indexOf(item), 1);
  }

  public friendlyReportType(reportType) {
    switch (reportType) {
      case 0:
        return 'Excel';
      case 1:
        return 'PDF';
      case 2:
        return 'WORD';

      case 3:
        return 'Dashboard';

    }
  }

  public series: any[] = [{
    name: 'India',
    data: [3.907, 7.943, 7.848, 9.284, 9.263, 9.801, 3.890, 8.238, 9.552, 6.855]
  }, {
    name: 'Russian Federation',
    data: [4.743, 7.295, 7.175, 6.376, 8.153, 8.535, 5.247, -7.832, 4.3, 4.3]
  }, {
    name: 'Germany',
    data: [0.010, -0.375, 1.161, 0.684, 3.7, 3.269, 1.083, -5.127, 3.690, 2.995]
  }, {
    name: 'World',
    data: [1.988, 2.733, 3.994, 3.464, 4.001, 3.939, 1.333, -2.245, 4.339, 2.727]
  }];
  public categories: number[] = [2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011];

  public async plotAreaClick(e: PlotAreaClickEvent, element) {
    if (element.filterColumn) {
      var self = this;
      if (e.category) {
        this.elementsLoading = true;
        if (this.loadingLookupsTask)
          await this.loadingLookupsTask;
        this.removeExistingFilterIfExsists(element);
        if (element.categoryIsDates) {
          // e.category = new Date(Date.UTC(e.category.getFullYear(), e.category.getMonth(), e.category.getDate(), e.category.getHours(), e.category.getMinutes()))
          var end = new Date(e.category.getTime());
          switch (element.baseUnit) {
            case 'hours':
              end.setHours(e.category.getHours() + 1);
              break;
            case 'days':
              end.setDate(e.category.getDate() + 1);
              break;
            case 'weeks':
              end.setDate(e.category.getDate() + 7);
              break;
            case 'months':
              end.setMonth(e.category.getMonth() + 1);
              break;
          }
          self.advancedFilters.push({ column: self.getColumn(element.filterColumn), columnName: element.filterColumn, start: e.category, end: end })
        }
        else self.advancedFilters.push({ column: self.getColumn(element.filterColumn), columnName: element.filterColumn, filterValue: e.category })
        self.generate(3);
      }
    }
  }
  public async onSeriesClick(e: SeriesClickEvent, element) {
    if (element.filterColumn) {
      var self = this;
      if (e.category) {
        this.elementsLoading = true;
        if (this.loadingLookupsTask)
          await this.loadingLookupsTask;
        this.removeExistingFilterIfExsists(element);
        if (element.categoryIsDates) {
          self.advancedFilters.push({ column: self.getColumn(element.filterColumn), columnName: element.filterColumn, start: e.category, end: e.category })
        }
        else self.advancedFilters.push({ column: self.getColumn(element.filterColumn), columnName: element.filterColumn, filterValue: e.category })
        self.generate(3);
      }
    }
  }
  public getColumn(columnName) {
    var filt = this.data.reportQueryFilter.reportEntity.reportQuerySelectGroup.reportQuerySelects.filter(o => { return o.columnName == columnName });
    if (filt.length > 0)
      return filt[0];
  }

  public removeExistingFilterIfExsists(element, generateReport?) {

    var existingFilter = this.advancedFilters.filter(o => { return o.columnName == element.filterColumn });
    if (existingFilter.length > 0) {
      existingFilter.forEach(o => {
        this.advancedFilters.splice(this.advancedFilters.indexOf(o), 1);
      })
    }
    if (generateReport)
      this.generate(3)
  }

  public elementFilterExists(element) {
    if (!element.filterColumn) return false;
    var existingFilter = this.advancedFilters.filter(o => { return o.columnName == element.filterColumn });
    return existingFilter.length > 0;
  }

  public stackSeriesLabelContent = (e: any) => {
    return e.series.stack.group[0];
  }
  public functionReturningString(e) {
    return e.value.toLocaleString()
  }
 

}
